import React from 'react';
import {
  ActiveSubscriptionConnectorApollo,
  SendRequestToRemoveAccountConnectorApollo,
} from '@front-activerse/common-components';
import RemoveAccountRequestContainer from './RemoveAccountRequestContainer';
import { useTimestamp } from '@front-activerse/common-components';

const RemoveAccountRequestPage: React.FC = () => {
  const { timestamp1 } = useTimestamp();

  return (
    <ActiveSubscriptionConnectorApollo>
      {(ActiveSubscriptionData: any) => (
        <SendRequestToRemoveAccountConnectorApollo>
          {(SendRequestToRemoveAccountData: any) => {
            return (
              <RemoveAccountRequestContainer
                key={timestamp1}
                loading={SendRequestToRemoveAccountData.loading || ActiveSubscriptionData.loading}
                sendRequestToRemoveAccount={() =>
                  SendRequestToRemoveAccountData.sendRequestToRemoveAccount()
                }
                activeSubscription={ActiveSubscriptionData.activeSubscriptions}
                userEmail={ActiveSubscriptionData.email}
              />
            );
          }}
        </SendRequestToRemoveAccountConnectorApollo>
      )}
    </ActiveSubscriptionConnectorApollo>
  );
};

export default RemoveAccountRequestPage;
